import { render, staticRenderFns } from "./GmvTable.vue?vue&type=template&id=73051109&scoped=true"
import script from "./GmvTable.vue?vue&type=script&lang=js"
export * from "./GmvTable.vue?vue&type=script&lang=js"
import style0 from "./GmvTable.vue?vue&type=style&index=0&id=73051109&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73051109",
  null
  
)

export default component.exports